import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isCollapsedSubject = new BehaviorSubject<boolean>(false);
  private isHiddenSubject = new BehaviorSubject<boolean>(false);
  private isMobileOpenSubject = new BehaviorSubject<boolean>(false);

  public isCollapsed$: Observable<boolean> = this.isCollapsedSubject.asObservable();
  public isHidden$: Observable<boolean> = this.isHiddenSubject.asObservable();
  public isMobileOpen$: Observable<boolean> = this.isMobileOpenSubject.asObservable();

  toggle(): void {
    this.isCollapsedSubject.next(!this.isCollapsedSubject.value);
  }

  setCollapsed(collapsed: boolean): void {
    this.isCollapsedSubject.next(collapsed);
  }

  getCollapsed(): boolean {
    return this.isCollapsedSubject.value;
  }

  setHidden(hidden: boolean): void {
    this.isHiddenSubject.next(hidden);
  }

  getHidden(): boolean {
    return this.isHiddenSubject.value;
  }

  toggleMobile(): void {
    this.isMobileOpenSubject.next(!this.isMobileOpenSubject.value);
  }

  setMobileOpen(open: boolean): void {
    this.isMobileOpenSubject.next(open);
  }

  getMobileOpen(): boolean {
    return this.isMobileOpenSubject.value;
  }

  closeMobile(): void {
    this.isMobileOpenSubject.next(false);
  }
}
